export default __webpack_public_path__ + "static/media/item_1@2x.3edc66fa.webp";